module.exports = __webpack_public_path__ + "img/selo-gptw-es.20136846.png";